<div class="price-input" [class.invalid]="!!error">
  <label [for]="inputId">{{ label }}</label>
  <div class="price-input__control">
    <span>{{ symbol }}</span>

    <input
      [id]="inputId"
      type="text"
      inputmode="decimal"
      autocomplete="off"
      [value]="displayValue"
      [placeholder]="placeholder"
      [disabled]="isDisabled"
      [attr.min]="min"
      [attr.max]="max"
      (focus)="onFocus()"
      (input)="onInput($event)"
      (blur)="onBlur()"
    />
  </div>
</div>
